@if (isDataLoaded && showPrimaryScreen) {
<div class="title-header nx-margin-0">
    <div nxLayout="grid maxwidth">
        <div nxRow>
            <div nxCol="12">
                @if(productName){<h1>{{productName.descp}}</h1>}
            </div>
        </div>
    </div>
</div>


@if (isShowTopMessage) {
<div class="button_area_bg">
    <div nxLayout="grid maxwidth">
      <div nxRow>
        <div nxCol="12">
            @if(hasCoverNoteGenerated() && status === statusMap['PENDING']) {
                <nx-message context="info" class="green_color_notification">
                    <span class="nx-font-weight-bold nx-margin-bottom-3xs"
                      >Your e-Cover Note has been submitted as pending approval.</span
                    ><br />
          
                    @if (cngeNote.referList && cngeNote.referList.length > 0) {
                    <span nxCopytext="normal"
                      >Referral reason:
                      <ul nxList="small" class="completed_list">
                        @for(item of cngeNote.referList; track item) {
                        <li>
                          <span class="nx-font-weight-bold">{{ item.referCode }}</span> - {{ item.referDescp }}
                        </li>
                        }
                      </ul>
                    </span>
                    }
                  </nx-message>
            }
            @if (isNotAllowCancel) {
            <nx-message context="info" class="green_color_notification">
                <span class="nx-font-weight-bold nx-margin-bottom-3xs">This e-Cover Note cannot be cancelled as a policy has been
                    generated. Kindly contact your branch.</span><br />
            </nx-message>
            }
            @if(isDirectCancel) {
                <nx-message context="info" class="green_color_notification">
                    <span class="nx-font-weight-bold nx-margin-bottom-3xs">{{ hasCoverNoteGenerated() ? 'e-Cover Note' : 'e-Quotation' }} has been cancelled successfully.</span>
                    <br />
                </nx-message>
            }
            
            @if(isQuotation && status === statusMap['EXPIRED'] && message) {
                <nx-message context="info" class="green_color_notification">
                    <span class="nx-font-weight-bold">Your e-Quotation is no longer valid.</span>
    
                    <div class="nx-margin-bottom-s"></div>
    
                    <span nxCopytext="normal">Reason:
                        <ul nxList="small" class="completed_list">
                            <li>{{ message }}</li>
                        </ul>
                    </span>
    
                </nx-message>
            }
        </div>
      </div>
    </div>
  </div>
}
<div class="button_area_bg" *ngIf="isFromMotorApproval && status != statusMap['PENDING']">
    <div nxLayout="grid maxwidth">
        <div nxRow>
            <div nxCol="12">
                <nx-message context="info" class="green_color_notification">
                    <span nxCopytext="normal">Referral reason:
                        <ul nxList="small" class="completed_list">
                            @for(referrer of referralReasonList; track referrer) {
                            <li>
                                <span class="nx-font-weight-bold">{{ referrer.code }}</span> - {{ referrer.desc }}
                            </li>
                            }
                        </ul>
                    </span>
                </nx-message>
            </div>
        </div>
    </div>
</div>
<div nxLayout="grid maxwidth">
    <div nxRow>

        <div nxCol="12,12,12,12" class="grid_width_page enquiry_no_spacing">
            <div nxLayout="grid nopadding" class="enquiry_status nx-margin-bottom-2m">
                <div nxRow class="enquiry_status">
                    <div nxCol="12,12,10">
                        <h3 nxHeadline size="s" class="nx-font-weight-regular">
                            {{ hasCoverNoteGenerated() ? 'e-Cover Note No. :' : 'e-Quotation No. :' }}
                            <span class="nx-font-weight-bold">{{proposalNo}}</span>
                        </h3>
                    </div>
                    <div nxCol="12,12,2" class="enquiry_status">
                        <nx-badge type="active" [class]="classType">{{status}}</nx-badge>
                    </div>
                </div>
            </div>


            <!-- //////////////////////////////////////////////////////////////////// -->
            <!-- Agent Information -->
            @if (showAgentInfo && this.agentData) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Agent Information
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <div nxLayout="grid nopadding">
                        <app-agents-information [agentData]="agentData">
                        </app-agents-information>
                    </div>
                </nx-expansion-panel>
            </nx-accordion>
            }


            <!-- //////////////////////////////////////////////////////////////////// -->
            <!-- Issuance Information -->
            @if (showIssuanceInfo && (productList && productList.length > 0)) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Issuance Information
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>

                    <div nxLayout="grid nopadding">
                        <app-issuance-information [progressType]="progressType" [issuanceInfo]="issuanceInfo"
                            [viewQuotation]=true [productList]="productList" [isFromMotorApproval]="isFromMotorApproval">
                        </app-issuance-information>
                    </div>
                </nx-expansion-panel>
            </nx-accordion>
            }

            <!-- //////////////////////////////////////////////////////////////////// -->
            <!-- Customer Partner -->
            @if (showCustomerPartner) {
            <nx-accordion variant="light">
                <nx-expansion-panel [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Customer Partner
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>

                    <app-customer-partner-details [viewOnly]="true" [cpType]="'FOUND'" [hideEdit]="true" [cpDetails]="cpData" [lov]="lov" [pCodeInfo]="issuanceInfo">
                    </app-customer-partner-details>

                </nx-expansion-panel>
            </nx-accordion>
            }

            <!-- ///////////////////////////////////////////////////////////////////// -->
            <!-- Referral Details -->
            @if (!showSalesmanID && showReferralDetails) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Referral Details
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <table nxTable class="summary_table" aria-label="referralDetailsTableDesc">
                        <tr nxTableRow>
                            <td nxTableCell>
                                <span nxCopytext="normal">Referral ID No.</span>
                            </td>
                            <td nxTableCell class="column_cp_content">
                                <span nxCopytext="normal"> {{ agentReferId ? agentReferId : 'N/A' }}</span>
                            </td>
                        </tr>
                    </table>
                </nx-expansion-panel>
            </nx-accordion>
            }

            <!-- ///////////////////////////////////////////////////////////////////// -->
            <!-- Salesman ID -->
            @if (showSalesmanID) {
                <nx-accordion variant="light">
                    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                        <nx-expansion-panel-header>
                            <nx-expansion-panel-title class="accordion_edit">
                                Salesman ID
                            </nx-expansion-panel-title>
                        </nx-expansion-panel-header>
                        <table nxTable cellpadding="0" class="summary_table">
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Salesman ID</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal"> {{ frStaffNo ? frStaffNo : 'N/A' }}</span>
                                </td>
                            </tr>
                        </table>
                    </nx-expansion-panel>
                </nx-accordion>
                }

            <!-- ////////////////////////////////////////////// -->
            <!-- Coverage -->
            @if (showCoverage) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordione_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Coverage
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>

                    <app-coverage-summary [coverageInfo]="coverageInfo"
                        [viewQuotation]="viewQuotation" [isRTP]="isRTP" [isIssuance]="isIssuance"></app-coverage-summary>


                </nx-expansion-panel>
            </nx-accordion>
            }

            @if (showRenewalAssistant) {
                <nx-accordion variant="light">
                    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                        <nx-expansion-panel-header>
                            <nx-expansion-panel-title class="accordion_edit"> Renewal Assistance: </nx-expansion-panel-title>
                        </nx-expansion-panel-header>
                        <table nxTable class="summary_table" aria-label="renewalDetailsTableDesc">
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Renewal Assistance</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal">{{ cngeNote?.autoRenewalInd ? 'YES' : 'NO' | uppercase }}</span>
                                </td>
                            </tr>
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Payment Mode:</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal">{{cngeNote?.creditCardType}}</span>
                                </td>
                            </tr>
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Credit Card No:</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal">{{cngeNote?.creditCardNo}}</span>
                                </td>
                            </tr>
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Credit Card Expiry Date:</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal"> {{ cngeNote?.creditCardExpMonth }} / {{ cngeNote?.creditCardExpYear }}</span>
                                </td>
                            </tr>
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Name on Card:</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal">{{cngeNote?.creditCardHolderName }}</span>
                                </td>
                            </tr>
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Renewal Assistance Start Date:</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal">{{ cngeNote?.autoRenewalStartDt | date:'dd/MM/yyyy' }}</span>
                                </td>
                            </tr>
                            <tr nxTableRow>
                                <td nxTableCell>
                                    <span nxCopytext="normal">Term of Use:</span>
                                </td>
                                <td nxTableCell class="column_cp_content">
                                    <span nxCopytext="normal">{{ cngeNote?.termsOfUse ? 'YES' : 'NO' | uppercase }}</span>
                                </td>
                            </tr>
                        </table>
                    </nx-expansion-panel>
                </nx-accordion>
                }


            <!-- ////////////////////////////////////////////// -->
            <!-- Historical Claim -->
            @if (showHistoricalClaim) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Allianz’s Historical Claim
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <table nxTable class="summary_table" aria-label="historicalClaimDetailsTableDesc">
                        <tr nxTableRow>
                            <td nxTableCell>
                                <span nxCopytext="normal">Client Claim History</span>
                            </td>
                            <td nxTableCell class="column_cp_content">
                                <span nxCopytext="normal">{{clientClaimHistory}}</span>
                            </td>
                        </tr>
                        <tr nxTableRow>
                            <td nxTableCell>
                                <span nxCopytext="normal">Vehicle Claim History</span>
                            </td>
                            <td nxTableCell class="column_cp_content">
                                <span nxCopytext="normal">{{vehicleClaimHistory}}</span>
                            </td>
                        </tr>
                    </table>
                </nx-expansion-panel>
            </nx-accordion>
            }

            <!-- ////////////////////////////////////////////// -->
            <!-- Premium Information -->
            @if (showPremiumInformation) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Premium Information
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>

                    <app-premium-information [ngClass]="{'card-inherit' : crossSellList && crossSellList.length !== 0 && isShowCrossSell}" [premiumInfo]="premiumInfo" [viewOnly]=true [isRTP]="isRTP" 
                    [isIssuance]="isIssuance" [productCode]="issuanceInfo.issuance.productCode" [coverageInfo]="coverageInfo">

                    </app-premium-information>

                </nx-expansion-panel>
            </nx-accordion>
            }

            @if (showPayment) {
                <nx-accordion variant="light">
                  <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                      <nx-expansion-panel-title class="accordion_edit"> Payment </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
              
                    <app-payment [payment]="payment"></app-payment>
              
                  </nx-expansion-panel>
                </nx-accordion>
              }

              @if (showRoadTaxPayable) {
                <nx-accordion variant="light">
                    <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                      <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit"> Road Tax Payable </nx-expansion-panel-title>
                      </nx-expansion-panel-header>
                      <app-view-road-tax-payable [data]="roadTaxPayable"></app-view-road-tax-payable>
                    </nx-expansion-panel>
                  </nx-accordion>
              }

              @if (showUpsellProduct) {
                <nx-accordion variant="light">
                  <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                      <nx-expansion-panel-title class="accordion_edit"> Upsell Product </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <app-view-upsell-product [data]="upsellProduct" [agentInfo]="agentInfo" [productCode]="cngeNote.productCode"></app-view-upsell-product>
                  </nx-expansion-panel>
                </nx-accordion>
              }

              @if (showPaymentInformation) {
                <app-payment-information [premiumInfo]="paymentInformation"></app-payment-information>
              }

              @if (showPaymentDetails) {
                <nx-accordion variant="light">
                  <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                      <nx-expansion-panel-title class="accordion_edit"> Payment Details </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <app-payment-details [userInfo]="userInfo" [agentInfo]="agentInfo" [paymentList]="paymentList"
                    [viewOnly]="true">
                    </app-payment-details>
                  </nx-expansion-panel>
                </nx-accordion>
              }

            <!-- ////////////////////////////////////////////// -->
            <!-- Remarks -->
            @if (showRemarks) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Remarks
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <app-view-remarks [remarksInfo]="remarksInfo" [isQuotationView]=true></app-view-remarks>
                </nx-expansion-panel> 
            </nx-accordion>
            }

            <!-- ////////////////////////////////////////////// -->
            <!-- Refer Case (if any) -->
            @if (showReferCase) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Refer Case (if any)
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <form [formGroup]="referCaseForm">
                        <div nxLayout="grid nopadding" class="grid_remove_padding">
                        </div>
                    </form>
                </nx-expansion-panel>
            </nx-accordion>
            }

            <!-- Endorsement Checklist (to be move to new component) -->
            <!-- ////////////////////////////////////////////////// -->
            <!-- Checklist -->
            @if (showChecklist) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Checklist
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>

                    <div nxLayout="grid nopadding" class="grid_remove_padding">
                        <!-- Amendment of Period, Extra Benefits, NCD Allowed, NCD Amendment, NCD Withdraw, Reinstatement of Extra Coverage, Revision of Sum Insured -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">1</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Insured or Agent Authorised letter / form / email (with
                                    contact number).</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- NCD Allowed, NCD Amendment -->
                        <div nxRow>
                            <div nxCol="12">
                                <p nxCopytext="medium" class="nx-margin-bottom-2m">
                                    <i>Note: Insured IC copy/E-payment form/copy of bank
                                        book-statement required (if refund involved).</i>
                                </p>
                            </div>
                        </div>

                        <!-- Amendment of Period -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">2</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Copy of VOC / Registration card (for brand new only).</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Cancellation by Insured, Hire Purchase/Employers' Loan/Leasing, Named Driver -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">1</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Insured Authorised letter/form/email (with contact
                                    number).</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div nxRow>
                            <div nxCol="12">
                                <p nxCopytext="medium" class="nx-margin-bottom-2m">
                                    <i>Note: Warranted no claim as at todate.</i>
                                </p>
                            </div>
                        </div>

                        <!-- Change of Bancassurance Details -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">1</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Internal email communication for changes.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Change of Vehicle Chassis No, Change Of Vehicle Registration Number, Change of Make & Model -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">1</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Insured or Agent Authorised letter/form/email (with contact
                                    number) OR</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Change of Vehicle Chassis No, Change Of Vehicle Registration Number, Change of Make & Model -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">2</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Copy of VOC/Registration card.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Extra Benefits, Named Driver, Revision of Sum Insured -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">2</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Vehicle inspection done.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Extra Benefits, Named Driver -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">3</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Warranted no claim as at todate.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div nxRow>
                            <div nxCol="12">
                                <p nxCopytext="medium" class="nx-margin-bottom-2m">
                                    <i>Note: Inclusion of extra benefits will only be allowed
                                        warranted no claim as at the date of endt.</i>
                                </p>
                            </div>
                        </div>

                        <!-- Named Driver -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">4</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Copy of I/C / passport.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- NCD Withdraw -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">2</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Claim/damage to the vehicle.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div nxRow>
                            <div nxCol="12">
                                <p nxCopytext="medium" class="nx-margin-bottom-2m">
                                    <i>Note: Insured IC copy/Epayment form/copy of bank
                                        book-statement required (if refund involved).</i>
                                </p>
                            </div>
                        </div>

                        <!-- Reinstatement of Extra Coverage -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">2</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Inspection done (required only if exceeded 14 days).</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Revision of Sum Insured -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">3</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Requested by Bank/Finance owner.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Revision of Sum Insured -->
                        <div nxRow class="nx-margin-bottom-2m">
                            <div nxCol="2,2,1" class="checklist">
                                <span nxCopytext="normal">4</span>
                            </div>
                            <div nxCol="10,10,11" class="checklist">
                                <span nxCopytext="normal">Purchase invoice - for new cases & vehicles from
                                    Langkawi/Labuan only.</span>
                                <div nxLayout="grid nopadding" class="grid_remove_padding nx-margin-top-s">
                                    <div nxRow>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">Yes</nx-radio>
                                        </div>
                                        <div nxCol="4,4,3,2" class="checklist_radio">
                                            <nx-radio name="yesno">No</nx-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div nxRow>
                            <div nxCol="12">
                                <p nxCopytext="medium" class="nx-margin-bottom-2m">
                                    <i>Note: Warranted no claim as at todate.</i>
                                </p>
                            </div>
                        </div>
                        <div nxRow>
                            <div nxCol="12">
                                <nx-formfield label="Remarks">
                                    <textarea nxInput type="text" #inputToCount maxlength="200"
                                        cdkTextareaAutosize></textarea>
                                    <span nxFormfieldHint>Max. 200 Characters</span>
                                </nx-formfield>
                            </div>
                        </div>
                    </div>
                </nx-expansion-panel>
            </nx-accordion>
            }

            <!-- Endorsement Narration (to be move to new component) -->

            <!-- ///////////////////////////////////////////////// -->
            <!-- Endorsement Narration -->
            @if (showEndorsementNarration) {
            <nx-accordion variant="light">
                <nx-expansion-panel class="accordion_btm_space">
                    <nx-expansion-panel-header>
                        <nx-expansion-panel-title class="accordion_edit">
                            Endorsement Narration
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>
                    <!-- CHANGE OF VEHICLE ENGINE NO./CUBIC CAPACITY -->
                    <u nxCopytext="normal" class="nx-font-weight-semibold">CHANGE OF VEHICLE ENGINE NO./CUBIC
                        CAPACITY</u>

                    <p nxCopytext="normal" class="nx-margin-y-m">
                        IT IS HEREBY DECLARED AND AGREED THAT EFFECTIVE
                        <span class="nx-font-weight-bold">13/12/2023</span> THE ENGINE
                        NUMBER AND/OR CUBIC CAPACITY IS/ARE AMENDED TO READ AS FOLLOWS AND
                        NOT AS OTHERWISE STATED.
                    </p>

                    <p nxCopytext="normal" class="nx-margin-bottom-m nx-font-weight-bold">
                        ENGINE / MOTOR NO. : 2NROP28330<br />CUBIC CAPACITY : 1,298 CC
                    </p>

                    <p nxCopytext="normal" class="nx-margin-y-m">
                        IN CONSIDERATION OF THE ABOVE, AN ADDITIONAL PREMIUM OF
                        <span class="nx-font-weight-bold">RM0.00</span> IS HEREBY CHARGED TO
                        THE INSURED.
                    </p>

                    <p nxCopytext="normal">
                        ALL OTHER TERMS AND CONDITIONS REMAIN UNCHANGED.
                    </p>

                    <!-- This is just spacing, you can remove it -->
                    <div class="nx-margin-y-2m"></div>

                    <!-- CHANGE OF MAKE & MODEL -->
                    <u nxCopytext="normal" class="nx-font-weight-semibold">CHANGE OF MAKE & MODEL</u>

                    <p nxCopytext="normal" class="nx-margin-y-m">
                        IT IS HEREBY DECLARED AND AGREED THAT EFFECTIVE
                        <span class="nx-font-weight-bold">13/12/2023</span> THE MAKE & MODEL
                        IS AMENDED TO READ AS FOLLOWS AND NOT AS OTHERWISE STATED.
                    </p>

                    <p nxCopytext="normal">MAKE & MODEL:</p>
                    <span nxCopytext="normal">
                        <ol nxList="small" class="upload_content nx-margin-bottom-2m">
                            <li>
                                <span class="nx-font-weight-bold">PERODUA MYVI 1.3 (A) SE</span>
                            </li>
                        </ol>
                    </span>

                    <p nxCopytext="normal">
                        ALL OTHER TERMS AND CONDITIONS REMAIN UNCHANGED.
                    </p>

                    <!-- This is just spacing, you can remove it -->
                    <div class="nx-margin-y-2m"></div>

                    <!-- INCLUSION OF NAMED DRIVER(S) -->
                    <u nxCopytext="normal" class="nx-font-weight-semibold">INCLUSION OF NAMED DRIVER(S)</u>

                    <p nxCopytext="normal" class="nx-margin-y-m">
                        IT IS HEREBY DECLARED AND AGREED THAT EFFECTIVE
                        <span class="nx-font-weight-bold">13/12/2023</span> THE FOLLOWING
                        NAMED DRIVER(S) IS/ARE INCLUDED INTO THE POLICY.
                    </p>

                    <p nxCopytext="normal" class="nx-font-weight-bold">
                        NO NAMED DRIVER(S) - DRIVER ID
                    </p>
                    <span nxCopytext="normal">
                        <ol nxList="small" class="upload_content_bold nx-margin-bottom-2m nx-font-weight-bold">
                            <li>
                                <span class="nx-font-weight-bold">WONG KAM WAI - 880914145277</span>
                            </li>
                        </ol>
                    </span>

                    <p nxCopytext="normal">
                        ALL OTHER TERMS AND CONDITIONS REMAIN UNCHANGED.
                    </p>
                </nx-expansion-panel>
            </nx-accordion>
            }



            <!-- //////////////////////////////////////////////////////////////////// -->
            @if (showEndorsementErrMessage) {
            <p nxCopytext="medium" class="nx-margin-top-2m">
                <i>* You will not be able to save as quotation, please proceed to
                    generate Endorsement if details has been finalised.</i>
            </p>
            }
        </div>
    </div>
</div>
@if (!isRTP) {
<div class="button_area_bg nx-margin-top-50">
    <div nxLayout="grid maxwidth">
      <div nxRow>
        <div nxCol="12">
            <div class="button-container-general">
                <button nxButton="secondary" type="button" 
                    (click)="redirectBack()" *ngIf="isShowBackBtn">
                    BACK
                </button>
                <button nxButton="secondary" type="button" 
                    (click)="prepareCancellationData()" [disabled]="isDisableRequestCancel()"
                    *ngIf="isShowRequestCancellationBtn">
                    Request Cancellation
                </button>
                <button nxButton="primary" type="button" 
                    (click)="showRemarksModal()" *ngIf="isShowAddRemarksBtn">
                    Referral Remarks
                </button>
                <button nxButton="primary" type="button" 
                    (click)="updatePayment()" *ngIf="isUpdatePaymentBtn" [disabled]="isDisableUpdatePayment()">
                    Update Payment
                </button>
                <button nxButton="primary" type="button" 
                    (click)="updateQuotation()" [disabled]="isDisableUpdateQuotation()" *ngIf="isShowUpdateQuotationBtn">
                    Update e-Quotation
                </button>
                <button nxButton="primary" type="button" [disabled]="isDisableQuotationPDF()"
                    (click)="downloadQuotationPDF('quotation', false)" *ngIf="isShowDownloadQuotationBtn">
                    <nx-icon name="download" nxIconPositionStart aria-hidden="true"></nx-icon>
                    E-Quotation PDF
                </button>
                <button nxButton="primary" type="button" [disabled]="isDisableCoverNotePDF()"
                    (click)="downloadCoverNotePDF('covernote', false)" *ngIf="isShowDownloadCoverNoteBtn">
                    <nx-icon name="download" nxIconPositionStart aria-hidden="true"></nx-icon>
                    E-Cover Note PDF
                </button>
                <button nxButton="primary" type="button" 
                    (click)="downloadPDF('invoice', false)" *ngIf="isShowDownloadInvoiceBtn" [disabled]="isDisableInvoicePDFButton()">
                    <nx-icon name="download" nxIconPositionStart aria-hidden="true"></nx-icon>
                    E-Invoice PDF
                </button>
                <button nxButton="primary" type="button" 
                    (click)="updateJPJDetails()" [disabled]="isDisableUpdateJPJButton()" *ngIf="isShowUpdateJPJBtn">
                    UPDATE JPJ DETAILS
                </button>
                <button nxButton="primary" type="button" 
                    (click)="amendCoverNote()" [disabled]="isDisableAmendOpenDateButton()" *ngIf="isShowAmendCoverNoteBtn">
                    AMEND OPEN DATED COVER NOTE
                </button>
                <button nxButton="primary" type="button" 
                    (click)="uploadDocument()" *ngIf="isShowUploadDocumentBtn">
                    UPLOAD DOCUMENT
                </button>
                <button nxButton="primary" type="button" 
                    (click)="checkQuotationStatus()" *ngIf="isShowEmailDocumentBtn" [disabled]="isDisableEmailButton()">
                    EMAIL DOCUMENT
                </button>
                <button nxButton="primary" type="button" 
                    (click)="requote()" *ngIf="isShowRequoteBtn">
                    RE-QUOTE
                </button>
            </div>
        </div>
      </div>
    </div>
  </div>
}
@if (isRTP) {
<div class="button_area_bg nx-margin-top-50">
    <div nxLayout="grid maxwidth">
        <div nxRow>
            <div nxCol="12">
                <button nxButton="secondary" type="button" (click)="redirectBack()">Back</button>
            </div>
        </div>
    </div>
</div>
}
}

@if (isDataLoaded && showSecondaryScreen) {
    <div class="title-header">
        <div nxLayout="grid maxwidth">
            <div nxRow>
                <div nxCol="12">
                    @if(productName){<h1>{{productName.descp}}</h1>}
                </div>
            </div>
        </div>
    </div>

    <div nxLayout="grid maxwidth">
        <div nxRow>
            <div nxCol="12,12,12,12" class="grid_width_page">
                
                <!-- //////////////////////////////////////////////////////////////////// -->
                <!-- Title -->
                <div nxLayout="grid nopadding" class="enquiry_status nx-margin-bottom-2m">
                    <div nxRow class="enquiry_status">
                        <div nxCol="12,12,10">
                            <h3 nxHeadline size="s" class="nx-font-weight-regular">
                                <span class="nx-font-weight-bold">{{ isUpdateJPJScreen ? 'Update JPJ Details' : 'Amend Open Dated Cover Note'}}</span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div nxLayout="grid nopadding" class="enquiry_status nx-margin-bottom-2m">
                    <div nxRow class="enquiry_status">
                        <div nxCol="12,12,10">
                            <h3 nxHeadline size="s" class="nx-font-weight-regular">
                                e-Cover Note No. :
                                <span class="nx-font-weight-bold">{{proposalNo}}</span>
                            </h3>
                        </div>
                    </div>
                </div>

                <!-- //////////////////////////////////////////////////////////////////// -->
                <!-- Agent Information -->
                @if (showAgentInfo && this.agentData) {
                <nx-accordion variant="light">
                    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                        <nx-expansion-panel-header>
                            <nx-expansion-panel-title class="accordion_edit">
                                Agent Information
                            </nx-expansion-panel-title>
                        </nx-expansion-panel-header>
                        <div nxLayout="grid nopadding">
                            <app-agents-information [agentData]="agentData">
                            </app-agents-information>
                        </div>
                    </nx-expansion-panel>
                </nx-accordion>
                }
                
                
                <!-- //////////////////////////////////////////////////////////////////// -->
                <!-- Issuance Information -->
                @if (showIssuanceInfo && isUpdateJPJScreen) {
                <nx-accordion variant="light">
                    <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
                        <nx-expansion-panel-header>
                            <nx-expansion-panel-title class="accordion_edit">
                                View / Update JPJ Details
                            </nx-expansion-panel-title>
                        </nx-expansion-panel-header>
                
                        <div nxLayout="grid nopadding">
                            <app-issuance-information [progressType]="progressType" [issuanceInfo]="issuanceInfo" [viewQuotation]=true [isUpdateJPJScreen]=true>
                            </app-issuance-information>
                        </div>
                    </nx-expansion-panel>
                </nx-accordion>
                }


                <!-- //////////////////////////////////////////////////////////////////// -->
                <!-- coverage Section - Vehicle Details -->
                @if (showCoverage) {
                <app-vehicle-view-amendment 
                    [isUpdateJPJScreen]="isUpdateJPJScreen" 
                    [isAmendDateScren]="isAmendDateScren"
                    [cngeNote]="cngeNote"
                    [coverageInfo]="coverageInfo">
                </app-vehicle-view-amendment>
                }

            </div>
        </div>
    </div>

    <div class="button_area_bg nx-margin-top-50">
        <div nxLayout="grid maxwidth">
            <div nxRow>
                <div nxCol="12">
                    <div class="button-container-general">
                        <button nxButton="secondary" type="button" 
                        (click)="exitUpdateScreen()" *ngIf="isUpdateJPJScreen">
                            BACK
                        </button>
                        <button nxButton="secondary" type="button" 
                        (click)="performCancel()" *ngIf="isAmendDateScren">
                            CANCEL
                        </button>
                        <button nxButton="primary" type="button" 
                        (click)="resendJPJAction()" *ngIf="isUpdateJPJScreen" [disabled]="isDisableResendJPJBtn()">
                            RESEND TO JPJ
                        </button>
                        <button nxButton="primary" type="button" 
                        (click)="saveCNDate()" *ngIf="isAmendDateScren" [disabled]="isDisableSaveAmendCNBtn()">
                            SAVE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
}

@if(crossSellList && crossSellList.length !== 0 && isShowCrossSell) {
    <app-cross-sell-banner [crossSellList]="crossSellList" [userInfo]="userInfo" 
    [marketingConsent]="marketingConsent" [clientPartnerInfo]="cpData" [agentInfo]="agentData">
    </app-cross-sell-banner>
}